export const STYLES = ["Rap", "Trap", "Drill", "R&B", "Afro", "Pop", "Hip-Hop", "Soul", "Dancehall", "Reggaeton", "Électro", "Autre"];

export const MOODS = ["sombre", "mélodique", "énergique", "triste", "romantique", "agressive", "chill", "planante"];

export const BUDGETS = ["À discuter", "0–50 €", "50–100 €", "100–250 €", "250–500 €", "500 €+"];

export const KEYS = ["", "C maj", "C min", "C# min", "D maj", "D min", "E min", "F maj", "F# min", "G maj", "G min", "A maj", "A min", "B min"];

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "à l'instant";
  if (s < 3600) return `il y a ${Math.floor(s / 60)} min`;
  if (s < 86400) return `il y a ${Math.floor(s / 3600)} h`;
  return `il y a ${Math.floor(s / 86400)} j`;
}
